<template>
  <div class="about">
    <div class="about-text">
      <h3>杭州珍炫科技有限公司</h3>
      <p>专业的移动互联网文娱产业内容分发</p>
      <span>运营服务商</span>
      <div>      杭州珍炫科技有限公司集研发、运营、渠道等资源优化为一体。杭州珍炫科技有限公司为融合不同客户群体需求，特推出杭州珍炫科技有限公司信息服务平台。目前平台开发了四大板块：广告策划、企业咨询、数字内容制作、系统平台搭建等，可以满足不同用户群体发布产品信息的需求。用户注册登录后，可以发布自己的产品信息，我们平台将为其做好精准推流和交易撮合服务，以便客户对接到合适的业务。</div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.about{
  width: 100%;
  height: 1063px;
  background: url("../assets/about.png") no-repeat;
  background-size: cover;
  display: flex;
    &-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 218px;
      h3{
        .fontdemo(47px, 'PingFangSC,PingFang SC', 600, #000000);
        margin: 0;
      }
      p{
        .fontdemo(30px, 'AlibabaPuHuiTi_2_65_Medium', 400, #3D75D2);
        margin-bottom: 10px;
      }
      span{
        .fontdemo(30px, 'AlibabaPuHuiTi_2_65_Medium', 400, #3D75D2);
        display: block;
        margin-bottom: 35px;
      }
      div{
        width: 700px;
        background: linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.9) 100%);
        border-radius: 40px;
        box-sizing: border-box;
        padding: 44px 55px;
        .fontdemo(25px, 'PingFangSC, PingFang SC', 500, rgba(37,49,68,0.85));
        line-height: 50px;
        text-align: left;
      }
    }
}
</style>